export function convertToRawValue(value: string) {
  function extractRawText(element) {
    let rawText = '';

    for (let node of element.childNodes) {
      if (node.nodeType === Node.TEXT_NODE) {
        rawText += node.textContent;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        rawText += extractRawText(node);
      }
    }

    return rawText;
  }

  const tempElement = document.createElement('div');
  tempElement.innerHTML = value;
  const rawValue = extractRawText(tempElement);

  return rawValue;
}
